import { AdminLinks } from '@app/modules/admin/routing/AdminLinks';
import { StreamerBoxLinks } from '@app/modules/streamer-box/routing/StreamerBoxLinks';
import { AuditLinks } from './audit/components/AuditLinks';
import { useIsContentAiEnabled } from './content-ai/hooks/useIsContentAiEnabled';
import { ContentAiLinks } from './content-ai/routing/ContentAiLinks';
import { FragmentsLinks } from './fragments/routing/FragmentsLinks';
import { LoggerLinks } from './logger/LoggerLinks';
import { SearchLinks } from './search/routing/SearchLinks';

export function ModulesNavLinks() {
  return (
    <>
      <LoggerLinks />
      <FragmentsLinks />
      <AuditLinks />
      <StreamerBoxLinks />
      <SearchLinks />
      {useIsContentAiEnabled() && <ContentAiLinks />}
      <AdminLinks />
    </>
  );
}
